<template>
<div class="users-out">
    <div class="users-manage">
      <!-- 列表 -->
      <el-table
       :data="tableData"
       style="width: 100%"
    >
        <el-table-column
          align="center"
          prop="timestr"
          :label="$t('allDomain.visitDate')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="host"
          :label="$t('allDomain.originAddr')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="statusCode"
          :label="$t('allDomain.status')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="methodName"
          :label="$t('allDomain.method')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="url"
          :label="$t('allDomain.InternetAddr')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="referer"
          :label="$t('allDomain.origin')"
        >
        </el-table-column>
      </el-table>
      <div class="pagination-bottom">
        <Pagination
          :total="total"
          :page-size="pageSize"
          :page-count="pageCount"
          @change="handleChange"
        />
      </div>
      <!-- 列表 -->
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import { visitLog } from '@/service/requestRes';
export default {
  props: {
    domainHost: String,
  },
  data() {
    return {
      tableData: [],
      total: 0,
      pageSize: 10,
      pageCount: 1,
    };
  },
  mounted() {
    this.getchildDomainList({page: 1});
  },
  computed: {
    headerLables() {
      return [
        { label: this.$t("allDomain.visitDate"), value: "timestr" },
        { label: this.$t("allDomain.originAddr"), value: "host" },
        { label: this.$t("allDomain.status"), value: "statusCode" },
        { label: this.$t("allDomain.method"), value: "methodName" },
        { label: this.$t("allDomain.InternetAddr"), value: "url" },
        { label: this.$t("allDomain.origin"), value: "referer" },
      ];
    },
  },
  methods: {
    getchildDomainList({ page }) {
      visitLog({
        page,
        host: this.domainHost,
        limit: this.pageSize,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          const { logs, count } = data || {};
          this.total = count;
          this.tableData = logs && logs.map(item => {
              const { method } = item || {};
              let methodName = '';
              if (method == 0) {
                  methodName = 'NoneType';
              } else if(method == 1) {
                  methodName = 'GET';
              } else if(method == 2) {
                  methodName = 'POST';
              } else if(method == 3) {
                  methodName = 'HEAD';
              } else if(method == 4) {
                  methodName = 'PUT';
              } else if(method == 5) {
                  methodName = 'DELETE';
              } else if(method == 6) {
                  methodName = 'PATCH';
              } else if(method == 7) {
                  methodName = 'CONNECT';
              } else if(method == 8) {
                  methodName = 'OPTIONS';
              } else if(method == 9) {
                  methodName = 'TRACE';
              }
              return {
                  ...item,
                  methodName,
                  timestr: this.$moment(item.time/1000000).format('YYYY-MM-DD HH:mm:ss')
              }
          });
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    handleChange(e) {
      this.getchildDomainList({ page: e });
    },
  },
};
</script>

<style lang="scss" scoped>
.users-out {
  width: 1276px;
  margin: 24px auto;
}
.users-manage {
  background-color: white;
  padding: 24px;
  border-radius: 4px;
  .user-handle {
    display: flex;
    align-items: center;
    :first-child {
      margin-right: 10px;
      width: 16px;
      height: 16px;
    }
    :last-child {
      width: 18px;
      height: 19px;
    }
  }

  .handle-first {
    display: flex;
    align-items: center;
    :nth-child(1) {
      margin-right: 10px;
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #4f81ff;
      cursor: pointer;
    }
    :nth-child(2) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      margin-right: 10px;
      cursor: pointer;
    }

    :nth-child(3) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      margin-right: 10px;
      color: #003600;
      cursor: pointer;
    }

    :nth-child(4) {
      font-family: PingFangSC-Semibold;
      font-size: 12px;
      color: #003600;
      cursor: pointer;
    }
  }
}
</style>
